module.exports = __webpack_public_path__ + "static/logo-1fb2229ba81694e506c40adbd3852925.png";